const OMD_MODAL_FADE_MS = 200;

class OmdModal {
    constructor(modalId) {
        this.modalElement = $(`#${modalId}`);
        $(`#${modalId} [data-omd-modal-close="true"]`).on('click', () => {
            this.close();
        });
    }

    onClose(onClose) {
        this._onClose = onClose;
    }

    open() {
        this.modalElement.fadeIn({
            duration: OMD_MODAL_FADE_MS,
        });
    }

    close() {
        this.modalElement.fadeOut({
            duration: OMD_MODAL_FADE_MS,
            done: () => {
                if (this._onClose) {
                    this._onClose();
                }
            }
        });
    }
}
